import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import {
  CreateTobaccoWorkOrder,
  DeleteTobaccoWorkOrder,
  GetTobaccoWorkOrderById,
  GetTobaccoWorkOrders,
  UpdateTobaccoWorkOrder,
} from './thunks';
import {
  ClearSelectedTobaccoWorkOrderReducer,
  CreateTobaccoWorkOrderReducer,
  DeleteTobaccoWorkOrderReducer,
  GetTobaccoWorkOrderByIdReducer,
  GetTobaccoWorkOrdersReducer,
  ResetTobaccoWorkOrdersStateReducer,
  UpdateTobaccoWorkOrderReducer,
} from './reducers';

export const slice = createSlice({
  name: 'tobaccoWorkOrders',
  initialState,
  reducers: {
    ClearSelectedTobaccoWorkOrder: ClearSelectedTobaccoWorkOrderReducer,
    ResetTobaccoWorkOrdersState: ResetTobaccoWorkOrdersStateReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetTobaccoWorkOrders, GetTobaccoWorkOrdersReducer);
    addExtraReducer(builder, GetTobaccoWorkOrderById, GetTobaccoWorkOrderByIdReducer);
    addExtraReducer(builder, CreateTobaccoWorkOrder, CreateTobaccoWorkOrderReducer);
    addExtraReducer(builder, UpdateTobaccoWorkOrder, UpdateTobaccoWorkOrderReducer);
    addExtraReducer(builder, DeleteTobaccoWorkOrder, DeleteTobaccoWorkOrderReducer);
  },
});

export default slice.reducer;
